import style from "./photoUploader.module.scss"

export const inputFields = {
    tagType: 'regular',
    label: "Image URLs",
    labelClass: style.label,
    inputClass: style.input,
    errorClass: style.error,
    id: "imageUrls",
    name: "imageUrls",
    type: "text",
    placeholder: "Enter image URLs",
    
  }